import React, {Fragment} from 'react';
import styled, {css} from "styled-components";
import Color from "color";
import ArrowRight from "../icons/ArrowRight";
import ArrowLeft from "../icons/ArrowLeft";

export default function ({handleButtonClick, leftEnabled, rightEnabled, align = 'bottom', ...props} ) {

  if(!leftEnabled && !rightEnabled) return null;

  return (
      <Fragment>

        <StyledButtonLeft onClick={() => handleButtonClick('left')} disabled={!leftEnabled} align={align}>
          <ArrowLeft style={carouselButtonIconStyle} />
        </StyledButtonLeft>

        <StyledButtonRight onClick={() => handleButtonClick('right')} disabled={!rightEnabled} align={align}>
          <ArrowRight style={carouselButtonIconStyle} />
        </StyledButtonRight>

      </Fragment>

  );
};

const carouselButtonIconStyle = {
  width: 'auto',
  height: '1.5rem',
  opacity: '.57',
};

const carouselButtonStyle = css`
  position: absolute;
  bottom: 2rem;
  
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  color: ${props => props.theme.accentColor};
  background-color: ${props => Color(props.theme.primaryBackgroundColor).alpha(.8).toString()};
  border: none;
  outline: none;
  
  &[disabled] {
    opacity: .2;
    cursor: default !important; // for some reason, without !important, it's not applied
  }
  
  &:hover {
    cursor: pointer;
  }
`;

const StyledButtonLeft = styled.button`
  left: ${ props => props.align === 'center' ? '4rem' : '1.875rem'};
  ${carouselButtonStyle}
  
  ${ props => props.align === 'center' && css `
    top: 50%;
    transform: translateY(-50%);
  `};
`;

const StyledButtonRight = styled.button`
  right: ${ props => props.align === 'center' ? '4rem' : '1.875rem'};
  ${carouselButtonStyle}
  
  ${ props => props.align === 'center' && css `
    top: 50%;
    transform: translateY(-50%);
  `};
`;
